import {
	APP_INIT,
} from "./types";

import { all, put } from "redux-saga/effects";

import { appSagas } from 'app/App/saga';

export default function* rootSaga() {
	yield all([
		...appSagas,
	]);

	yield put({type: APP_INIT});
};